import React from 'react';
import {TransfersLoadingDialog} from './TransfersLoadingDialog';
import {TransfersProvider} from '../context/TransfersContext';
import {TransfersCard} from './TransfersCard';

export function TransfersPage() {

  return (
    <TransfersProvider>
      <TransfersLoadingDialog />
      <TransfersCard />
    </TransfersProvider>
  );
}
